export default "__VITE_PUBLIC_ASSET__7ad25e22__"